import { useQuery } from "@apollo/client"
import { useState } from "react"
import { Flex, Button, Box, Text, Image } from "rebass/styled-components"
import Modal from "styled-react-modal"
import doctorIcon from '../../static/doctorIcon.png';
import PleaseWait from "../../components/PleaseWait"
import { GET_APPOINTMENT_SUMMARY, GET_APPOINTMENT_NOTES } from "../../graphql/queries"
import { IProviderGetAppointmentSummaryOutput, IProviderGetAppointmentSummaryInput, IGetAppointmentNotesOutput, IGetAppointmentNotesInput, IAppointmentListEntry } from "../../graphql/types/queries/appointment"
import { AddAppointmentNote } from "../patient/components/AddAppointmentNote"

export const AppointmentDetails = ({ data, isPast }: { data: IAppointmentListEntry, isPast: boolean }) => {
  const [isAddNote, setIsAddNote] = useState(false)

  const { loading, error, data: dataSummary } = useQuery<IProviderGetAppointmentSummaryOutput, IProviderGetAppointmentSummaryInput>(GET_APPOINTMENT_SUMMARY, {
    variables: {
      appointmentId: data.appointmentId!
    }
  })
  const { loading: loadingNotes, error: errorNotes, data: dataNotes } = useQuery<IGetAppointmentNotesOutput, IGetAppointmentNotesInput>(GET_APPOINTMENT_NOTES, {
    variables: {
      appointmentId: data.appointmentId!
    }
  })

  return (
    <Flex width={'100%'} flexDirection='column' mt={2} padding='0 16px'>

      {!!loadingNotes ? (<Flex flex={1} flexDirection={'column'} justifyContent='center' alignItems={'center'} >
        <PleaseWait
          text={` `} />
      </Flex>) : !dataNotes?.healthCoachGetAppointmentNotes || dataNotes.healthCoachGetAppointmentNotes.length < 1 ? (
        <Flex alignItems={'center'} justifyContent={'center'} flexDirection={'column'}>
          <Text fontSize='12px' mt={3} mb={2} style={{ opacity: 0.5 }}>No Appointment Notes</Text>
          <Button mt={3} onClick={() => setIsAddNote(true)} variant={'primary'} style={{ padding: '4px 16px', height: 'fit-content', width: 'fit-content', fontSize: '12px' }}>Add appointment note</Button>
        </Flex>
      ) : (
        <>
          <Text fontSize='14px'>Appointment Notes:</Text>
          {dataNotes.healthCoachGetAppointmentNotes.map(note => {
            return (<Text ml={3} fontSize='12px'>{`• ${note.noteText}`}</Text>)
          })}
          <Button mt={3} onClick={() => setIsAddNote(true)} variant={'primary'} style={{ padding: '4px 16px', height: 'fit-content', width: 'fit-content', fontSize: '12px' }}>Add appointment note</Button>
        </>
      )}

      {!!isPast && (
        <>

          {!!loading ? (<Flex flex={1} flexDirection={'column'} justifyContent='center' alignItems={'center'} >
            <PleaseWait
              text={` `} />
          </Flex>) : !dataSummary?.providerGetAppointmentSummary ? (
            <Text fontSize='12px' mt={3}>No Summary Information</Text>
          ) : ((<Flex flexDirection={'row'}>
            <Flex flexDirection={'column'}>
              <Flex alignItems={'center'} mt={3}>
                <Image src={doctorIcon} width='32px' height={'32px'} mr={3} />
                <Text fontSize='18px'>Visit Summary</Text>
              </Flex>
              <Text ml={['8px', '50px', '50px']} fontSize='14px' fontWeight={500} mt={3}>Patient instructions</Text>
              <Text paddingY={'8px'} ml={['12px', '62px', '50px']} style={{
                paddingLeft: '12px',
                borderLeft: '1px solid #344F7A99'
              }} fontWeight={300} fontSize='12px' dangerouslySetInnerHTML={{
                __html: dataSummary.providerGetAppointmentSummary.instructions || ''
              }}></Text>

              <Text ml={['8px', '50px', '50px']} fontSize='14px' fontWeight={500} mt={4}>Patient goals</Text>
              <Text paddingY={'8px'} ml={['12px', '62px', '50px']} style={{
                paddingLeft: '12px',
                borderLeft: '1px solid #344F7A99'
              }} fontWeight={300} fontSize='12px' mt={3} dangerouslySetInnerHTML={{
                __html: dataSummary.providerGetAppointmentSummary.goals || ''
              }} />


              <Text ml={['8px', '50px', '50px']} fontSize='14px' fontWeight={500} mt={4}>Discussion notes</Text>
              <Text paddingY={'8px'} ml={['12px', '62px', '50px']} style={{
                paddingLeft: '12px',
                borderLeft: '1px solid #344F7A99'
              }} fontWeight={300} fontSize='12px' mt={3} dangerouslySetInnerHTML={{
                __html: dataSummary.providerGetAppointmentSummary.discussionNotes || ''
              }} />

              <Text ml={['8px', '50px', '50px']} fontSize='14px' fontWeight={500} mt={4}>Assessment</Text>
              <Text paddingY={'8px'} ml={['12px', '62px', '50px']} style={{
                paddingLeft: '12px',
                borderLeft: '1px solid #344F7A99'
              }} fontWeight={300} fontSize='12px' mt={3} dangerouslySetInnerHTML={{
                __html: dataSummary.providerGetAppointmentSummary.assessment || ''
              }} />

              <Text ml={['8px', '50px', '50px']} fontSize='14px' fontWeight={500} mt={4}>Prescription</Text>
              <Box ml={['12px', '62px', '50px']} style={{
                paddingLeft: '12px',
                borderLeft: '1px solid red'
              }}>
                {dataSummary.providerGetAppointmentSummary.prescription?.map(
                  x => {
                    return (
                      <Flex flexDirection={'column'}>
                        <Text fontWeight={500} fontSize='12px' mt={'8px'}>{x.description}</Text>
                        <Text fontWeight={300} fontSize='12px' >{x.dosageQuantity} {x.quantityValue}</Text>
                        <Text fontWeight={300} fontSize='12px' >{x.instructions}</Text>

                      </Flex>
                    )
                  }
                )}
              </Box>
              <Text ml={['8px', '50px', '50px']} fontSize='14px' fontWeight={500} mt={3}>HPI</Text>
              <Text paddingY={'8px'} ml={['12px', '62px', '50px']} style={{
                paddingLeft: '12px',
                borderLeft: '1px solid #344F7A99'
              }} fontWeight={300} fontSize='12px' dangerouslySetInnerHTML={{
                __html: (dataSummary.providerGetAppointmentSummary.hpi || '').replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '<br />')
              }}></Text>
              <Text ml={['8px', '50px', '50px']} fontSize='14px' fontWeight={500} mt={3}>Physical Exam</Text>
              <Text paddingY={'8px'} ml={['12px', '62px', '50px']} style={{
                paddingLeft: '12px',
                borderLeft: '1px solid #344F7A99'
              }} fontWeight={300} fontSize='12px' dangerouslySetInnerHTML={{
                __html: (dataSummary.providerGetAppointmentSummary.physicalExam || '').replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '<br />')
              }}></Text>


            </Flex>
          </Flex>))}
        </>
      )}
      {isAddNote && (
        <Modal
          isOpen={!!isAddNote}
          onBackgroundClick={() => setIsAddNote(false)}
          onEscapeKeydown={() => setIsAddNote(false)}>
          <AddAppointmentNote appointmentId={data.appointmentId} close={() => { setIsAddNote(false) }} />
        </Modal>
      )}
    </Flex>
  )
}